import React from "react";
import modelsList from "../../SuzukiModelsList";
import "./VehiclesListItem.sass";

const VehiclesListItem = ({ model, handleListItemClick }) => {
  return (
    <div
      className="vehicle-list-item"
      onClick={() => {
        handleListItemClick(model);
      }}
    >
      <p className="light-text">{model}</p>
    </div>
  );
};

export default VehiclesListItem;
